// index.ts - Simplified and more robust
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation resources
import enTranslation from './locals/en'
import trTranslation from './locals/tr'
import ruTranslation from './locals/ru'

export const defaultNS = 'common'
export const resources = {
    en: enTranslation,
    tr: trTranslation,
    ru: ruTranslation,
} as const

export const availableLanguages = Object.keys(resources) as Array<keyof typeof resources>

const STORAGE_KEY = 'vdex-language'

// Safe localStorage access with fallback
const getStoredLanguage = (): string => {
    try {
        return localStorage.getItem(STORAGE_KEY) || 'en'
    } catch {
        return 'en'
    }
}

const setStoredLanguage = (lng: string): void => {
    try {
        localStorage.setItem(STORAGE_KEY, lng)
    } catch {
        // Silent fail if localStorage is not available
    }
}

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        defaultNS,
        ns: ['common', 'navbar', 'vmm', 'trade', 'competition', 'refer', 'margin', 'notifications', 'pagination', 'profile', 'refer'],
        resources,
        lng: getStoredLanguage(),
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false,
        },

        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: STORAGE_KEY,
        },

        react: {
            useSuspense: false,
        }
    })

// Listen for language changes and update localStorage
i18n.on('languageChanged', (lng: string) => {
    setStoredLanguage(lng)
})

export default i18n